import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { PaginatedResponse } from '@synergy/api';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';

import { Api } from '../../../../../api';
import { AppState } from '../../../../../store/models/app-state';
import { HeaderBannerDto } from '../../models/header-banner-dto';
import { ReduxDispatch } from '../../../../../store/use-thunk-dispatch';

export const HEADER_BANNER_LIST_FETCH = 'HEADER_BANNER_LIST_FETCH';
export const HEADER_BANNER_LIST_RECEIVE = 'HEADER_BANNER_LIST_RECEIVE';
export const HEADER_BANNER_LIST_ERROR = 'HEADER_BANNER_LIST_ERROR';

export const receiveHeaderBannerList = (headerBanners: PaginatedResponse<HeaderBannerDto>) => {
    return {
        type: HEADER_BANNER_LIST_RECEIVE,
        headerBanners,
    };
};

export const fetchHeaderBannerList = (searchParams: URLSearchParams = new URLSearchParams()) => {
    return async (dispatch: ReduxDispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: HEADER_BANNER_LIST_FETCH });
        const response = await api.contentManagement.HeaderBanner.HeaderBannerList.getHeaderBanners(searchParams);
        if (response.success) {
            dispatch(receiveHeaderBannerList(response.result));
        } else {
            dispatch({ type: HEADER_BANNER_LIST_ERROR });
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
